import React from 'react';
import { FormSpy } from 'react-final-form';
import { CSSTransition } from 'react-transition-group';
import { InputButtonRadio } from 'timeone-components';
import styled from 'styled-components';
import { transparentize } from 'polished';

const InputRadioStyled = styled(InputButtonRadio)`
  align-items: flex-start;
  margin: 0 1rem 0 0;

  .input-check-mark {
    border-color: ${({ theme }) => theme.colors.blue};
    position: relative;
    transition: all 0.25s;

    &::after {
      background-color: ${({ theme }) => theme.colors.blue};
      border-radius: 50%;
      content: '';
      display: block;
      height: 0.375rem;
      left: 0.1625rem;
      position: absolute;
      top: 0.2rem;
      visibility: hidden;
      width: 0.375rem;
    }
    &.active{
      background-color: #ffffff;
    }
  }

  &:hover .input-check-mark {
    background-color: ${({ theme }) => transparentize(0.75, theme.colors.gray)};
  }

  &.active-enter-done .input-check-mark::after {
    visibility: visible;
  }
`;

function InputRadio(props) {
  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => (
        <CSSTransition in={values[props.name] === `${props.value}`} classNames="active" timeout={0}>
          <InputRadioStyled {...props} />
        </CSSTransition>
      )}
    </FormSpy>
  );
}

export default InputRadio;
